import { Component, Input } from '@angular/core';
import { AccountsDisplayingFormat, PaymentCardNumberFormat } from '@backbase/ui-ang';


export type AccountStatus = 'closed' | 'inactive' | 'active';

@Component({
  selector: 'bn-product-item-basic-account-ui',
  templateUrl: './bn-account-item-basic-account.component.html',
})
export class ProductItemBasicAccountComponent {

  readonly hostRef: ProductItemBasicAccountComponent = this;
  /**
   * The card Title value. Default is empty string
   */
  @Input() title: string | undefined;
  /**
   * The product Number. Default is empty string
   */
  @Input() productNumber: string | undefined;
  /**
   * Configuration of how the product number should be formatted.
   */
  @Input() productNumberFormat!: AccountsDisplayingFormat ;
  /**
   * The card currency value. Default is empty string
   */
  @Input() currency?: string | undefined;
  /**
   * Foreign currency
   */
  @Input() foreignCurrency?: string | undefined;

  /**
   * Will show currency Symbol in amount. Default value true
   */
  @Input() showCurrencySymbol = true;
  /**
   * The card Amount value
   */
  @Input() amount?: number | undefined;
  /**
   * Foreign amount
   */
  @Input() foreignAmount?: number | undefined;
  /**
   * The card highlight the amount and currency value
   */
  @Input() highlight?: boolean;
  /**
   * The product details info values
   */
  @Input()
  productDetailsInfo?: {
    [key: string]: any;
  };
  /**
   * The active state of card (it adds active class for blue line)
   */
  @Input() active = true;
  /**
   * The favorite state of card (add favorite icon next to title)
   */
  @Input() favorite = false;
  /**
   * The favorite icon color (define star icon color)
   */
  @Input() favoriteIconColor = 'primary';
  /**
   * The selected state of card (it removes check mark)
   */
  @Input() selected = false;
  /**
   * Type of account (define selected item icon)
   */
  @Input() type: string | undefined;
  /**
   * Current account status (ex: closed, inactive, active)
   */
  @Input() status: AccountStatus | undefined;
  /**
   * Balance label (ex: Available balance, Current balance)
   */
  @Input() balanceLabel: string | undefined;
  /**
   * Branch Code of bank
   */
  @Input() bankBranchCode: string | undefined;

  applyMaskToCreditCardNumber(creditCardNumber: string): string {
    return creditCardNumber.replace(/(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 ****');
  }
}
